import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '48',
  height: '30',
  viewBox: '0 0 48 30'
}, [
  h('path', {
    d: 'M11.5 29.9C6 29.9 1.9 28.3.7 25.2-1.5 19.4 7 10.9 20 5.9c4.4-1.7 8.9-2.9 13-3.3.6 0 1 .3 1.1.9.1.5-.3 1-.9 1.1-3.9.4-8.2 1.5-12.5 3.1C7.9 12.7 1 20.4 2.6 24.5c1.6 4.1 11.9 5 24.7.1 12.8-5 19.8-12.7 18.2-16.7-.6-1.6-2.4-2.4-3.7-2.8-.5-.2-.8-.7-.7-1.2.2-.5.7-.8 1.2-.7 2.6.8 4.3 2.1 5 4C49.5 12.8 41 21.3 28 26.4c-6 2.3-11.8 3.5-16.5 3.5z'
  }),
  h('path', {
    d: 'M15 25.2c-.5 0-1-.4-1-1s.4-1 1-1c3.1 0 7-.9 10.8-2.4 8-3.1 13-7.9 12.2-10.1-.4-1-2.3-1.6-5-1.6-3.1 0-7 .9-10.8 2.4-5 1.9-9.3 4.7-11.2 7.3-.3.4-1 .5-1.4.2-.4-.3-.5-1-.2-1.4 2.2-2.9 6.7-5.8 12.1-7.9C25.6 8 29.7 7.1 33 7.1c3.8 0 6.1 1 6.8 2.9 1.6 4.2-5.6 9.7-13.3 12.7-4.1 1.5-8.1 2.4-11.5 2.5z'
  }),
  h('path', {
    d: 'M23 20.1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM38 6.1c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM10 26.1c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/sidepanel-spaces-advice.es6.js